import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

export const createUserIfNotExists = async (user) => {
    const userRef = doc(db, "users", user.uid); // ✅ use UID

    const docSnap = await getDoc(userRef);

    if (!docSnap.exists()) {
        const username = user.email.split("@")[0];

        await setDoc(userRef, {
            email: user.email,
            name: user.displayName,
            username: username, // ✅ NEW
            privacy: "public",
            createdAt: new Date()
        });
    }

    return user.uid; // ✅ userId = UID
};